/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onCreateCustomer(filter: $filter) {
      id
      name
      active
      trial
      usernames
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onUpdateCustomer(filter: $filter) {
      id
      name
      active
      trial
      usernames
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onDeleteCustomer(filter: $filter) {
      id
      name
      active
      trial
      usernames
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAssessment = /* GraphQL */ `
  subscription OnCreateAssessment(
    $filter: ModelSubscriptionAssessmentFilterInput
  ) {
    onCreateAssessment(filter: $filter) {
      id
      name
      description
      contactPerson
      type
      imageKey
      active
      public
      language
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      modules {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAssessment = /* GraphQL */ `
  subscription OnUpdateAssessment(
    $filter: ModelSubscriptionAssessmentFilterInput
  ) {
    onUpdateAssessment(filter: $filter) {
      id
      name
      description
      contactPerson
      type
      imageKey
      active
      public
      language
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      modules {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAssessment = /* GraphQL */ `
  subscription OnDeleteAssessment(
    $filter: ModelSubscriptionAssessmentFilterInput
  ) {
    onDeleteAssessment(filter: $filter) {
      id
      name
      description
      contactPerson
      type
      imageKey
      active
      public
      language
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      modules {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAssessmentAssignment = /* GraphQL */ `
  subscription OnCreateAssessmentAssignment(
    $filter: ModelSubscriptionAssessmentAssignmentFilterInput
  ) {
    onCreateAssessmentAssignment(filter: $filter) {
      id
      customerID
      assessmentID
      performAssessments {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      version
      package
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAssessmentAssignment = /* GraphQL */ `
  subscription OnUpdateAssessmentAssignment(
    $filter: ModelSubscriptionAssessmentAssignmentFilterInput
  ) {
    onUpdateAssessmentAssignment(filter: $filter) {
      id
      customerID
      assessmentID
      performAssessments {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      version
      package
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAssessmentAssignment = /* GraphQL */ `
  subscription OnDeleteAssessmentAssignment(
    $filter: ModelSubscriptionAssessmentAssignmentFilterInput
  ) {
    onDeleteAssessmentAssignment(filter: $filter) {
      id
      customerID
      assessmentID
      performAssessments {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      version
      package
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateModule = /* GraphQL */ `
  subscription OnCreateModule($filter: ModelSubscriptionModuleFilterInput) {
    onCreateModule(filter: $filter) {
      id
      sortingNumber
      title
      assessmentID
      ownerGroups
      questions {
        nextToken
        __typename
      }
      structuredEntries {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateModule = /* GraphQL */ `
  subscription OnUpdateModule($filter: ModelSubscriptionModuleFilterInput) {
    onUpdateModule(filter: $filter) {
      id
      sortingNumber
      title
      assessmentID
      ownerGroups
      questions {
        nextToken
        __typename
      }
      structuredEntries {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteModule = /* GraphQL */ `
  subscription OnDeleteModule($filter: ModelSubscriptionModuleFilterInput) {
    onDeleteModule(filter: $filter) {
      id
      sortingNumber
      title
      assessmentID
      ownerGroups
      questions {
        nextToken
        __typename
      }
      structuredEntries {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateQuestion = /* GraphQL */ `
  subscription OnCreateQuestion($filter: ModelSubscriptionQuestionFilterInput) {
    onCreateQuestion(filter: $filter) {
      id
      title
      package
      text
      source
      moduleID
      ownerGroups
      requirements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateQuestion = /* GraphQL */ `
  subscription OnUpdateQuestion($filter: ModelSubscriptionQuestionFilterInput) {
    onUpdateQuestion(filter: $filter) {
      id
      title
      package
      text
      source
      moduleID
      ownerGroups
      requirements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteQuestion = /* GraphQL */ `
  subscription OnDeleteQuestion($filter: ModelSubscriptionQuestionFilterInput) {
    onDeleteQuestion(filter: $filter) {
      id
      title
      package
      text
      source
      moduleID
      ownerGroups
      requirements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRequirement = /* GraphQL */ `
  subscription OnCreateRequirement(
    $filter: ModelSubscriptionRequirementFilterInput
  ) {
    onCreateRequirement(filter: $filter) {
      id
      questionID
      text
      weight
      gradations
      ownerGroups
      recommendations {
        nextToken
        __typename
      }
      requirementAnswers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRequirement = /* GraphQL */ `
  subscription OnUpdateRequirement(
    $filter: ModelSubscriptionRequirementFilterInput
  ) {
    onUpdateRequirement(filter: $filter) {
      id
      questionID
      text
      weight
      gradations
      ownerGroups
      recommendations {
        nextToken
        __typename
      }
      requirementAnswers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRequirement = /* GraphQL */ `
  subscription OnDeleteRequirement(
    $filter: ModelSubscriptionRequirementFilterInput
  ) {
    onDeleteRequirement(filter: $filter) {
      id
      questionID
      text
      weight
      gradations
      ownerGroups
      recommendations {
        nextToken
        __typename
      }
      requirementAnswers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRecommendation = /* GraphQL */ `
  subscription OnCreateRecommendation(
    $filter: ModelSubscriptionRecommendationFilterInput
  ) {
    onCreateRecommendation(filter: $filter) {
      id
      requirementID
      level
      description
      recommendationText
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRecommendation = /* GraphQL */ `
  subscription OnUpdateRecommendation(
    $filter: ModelSubscriptionRecommendationFilterInput
  ) {
    onUpdateRecommendation(filter: $filter) {
      id
      requirementID
      level
      description
      recommendationText
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRecommendation = /* GraphQL */ `
  subscription OnDeleteRecommendation(
    $filter: ModelSubscriptionRecommendationFilterInput
  ) {
    onDeleteRecommendation(filter: $filter) {
      id
      requirementID
      level
      description
      recommendationText
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateStructuredEntry = /* GraphQL */ `
  subscription OnCreateStructuredEntry(
    $filter: ModelSubscriptionStructuredEntryFilterInput
  ) {
    onCreateStructuredEntry(filter: $filter) {
      id
      title
      description
      source
      entries {
        impact
        risk
        opportunity
        example
        __typename
      }
      threshold
      moduleID
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateStructuredEntry = /* GraphQL */ `
  subscription OnUpdateStructuredEntry(
    $filter: ModelSubscriptionStructuredEntryFilterInput
  ) {
    onUpdateStructuredEntry(filter: $filter) {
      id
      title
      description
      source
      entries {
        impact
        risk
        opportunity
        example
        __typename
      }
      threshold
      moduleID
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteStructuredEntry = /* GraphQL */ `
  subscription OnDeleteStructuredEntry(
    $filter: ModelSubscriptionStructuredEntryFilterInput
  ) {
    onDeleteStructuredEntry(filter: $filter) {
      id
      title
      description
      source
      entries {
        impact
        risk
        opportunity
        example
        __typename
      }
      threshold
      moduleID
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePerformAssessment = /* GraphQL */ `
  subscription OnCreatePerformAssessment(
    $filter: ModelSubscriptionPerformAssessmentFilterInput
  ) {
    onCreatePerformAssessment(filter: $filter) {
      id
      assessmentState
      assessmentAssignmentID
      requirementAnswers {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePerformAssessment = /* GraphQL */ `
  subscription OnUpdatePerformAssessment(
    $filter: ModelSubscriptionPerformAssessmentFilterInput
  ) {
    onUpdatePerformAssessment(filter: $filter) {
      id
      assessmentState
      assessmentAssignmentID
      requirementAnswers {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePerformAssessment = /* GraphQL */ `
  subscription OnDeletePerformAssessment(
    $filter: ModelSubscriptionPerformAssessmentFilterInput
  ) {
    onDeletePerformAssessment(filter: $filter) {
      id
      assessmentState
      assessmentAssignmentID
      requirementAnswers {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRequirementAnswer = /* GraphQL */ `
  subscription OnCreateRequirementAnswer(
    $filter: ModelSubscriptionRequirementAnswerFilterInput
  ) {
    onCreateRequirementAnswer(filter: $filter) {
      id
      requirementID
      performedAssessmentID
      selectedLevel
      fulfilled
      irrelevant
      comment
      contactPerson
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRequirementAnswer = /* GraphQL */ `
  subscription OnUpdateRequirementAnswer(
    $filter: ModelSubscriptionRequirementAnswerFilterInput
  ) {
    onUpdateRequirementAnswer(filter: $filter) {
      id
      requirementID
      performedAssessmentID
      selectedLevel
      fulfilled
      irrelevant
      comment
      contactPerson
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRequirementAnswer = /* GraphQL */ `
  subscription OnDeleteRequirementAnswer(
    $filter: ModelSubscriptionRequirementAnswerFilterInput
  ) {
    onDeleteRequirementAnswer(filter: $filter) {
      id
      requirementID
      performedAssessmentID
      selectedLevel
      fulfilled
      irrelevant
      comment
      contactPerson
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateEvaluation = /* GraphQL */ `
  subscription OnCreateEvaluation(
    $filter: ModelSubscriptionEvaluationFilterInput
  ) {
    onCreateEvaluation(filter: $filter) {
      id
      introText
      performedAssessmentID
      assessmentAssignmentID
      evaluationModuleData {
        nextToken
        __typename
      }
      state
      language
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEvaluation = /* GraphQL */ `
  subscription OnUpdateEvaluation(
    $filter: ModelSubscriptionEvaluationFilterInput
  ) {
    onUpdateEvaluation(filter: $filter) {
      id
      introText
      performedAssessmentID
      assessmentAssignmentID
      evaluationModuleData {
        nextToken
        __typename
      }
      state
      language
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEvaluation = /* GraphQL */ `
  subscription OnDeleteEvaluation(
    $filter: ModelSubscriptionEvaluationFilterInput
  ) {
    onDeleteEvaluation(filter: $filter) {
      id
      introText
      performedAssessmentID
      assessmentAssignmentID
      evaluationModuleData {
        nextToken
        __typename
      }
      state
      language
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateEvaluationModuleData = /* GraphQL */ `
  subscription OnCreateEvaluationModuleData(
    $filter: ModelSubscriptionEvaluationModuleDataFilterInput
  ) {
    onCreateEvaluationModuleData(filter: $filter) {
      id
      relatedEvaluationId
      moduleID
      resultText
      rating
      maxRating
      questionRating {
        questionID
        rating
        maxRating
        hasAnswer
        __typename
      }
      completelyAnswered
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEvaluationModuleData = /* GraphQL */ `
  subscription OnUpdateEvaluationModuleData(
    $filter: ModelSubscriptionEvaluationModuleDataFilterInput
  ) {
    onUpdateEvaluationModuleData(filter: $filter) {
      id
      relatedEvaluationId
      moduleID
      resultText
      rating
      maxRating
      questionRating {
        questionID
        rating
        maxRating
        hasAnswer
        __typename
      }
      completelyAnswered
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEvaluationModuleData = /* GraphQL */ `
  subscription OnDeleteEvaluationModuleData(
    $filter: ModelSubscriptionEvaluationModuleDataFilterInput
  ) {
    onDeleteEvaluationModuleData(filter: $filter) {
      id
      relatedEvaluationId
      moduleID
      resultText
      rating
      maxRating
      questionRating {
        questionID
        rating
        maxRating
        hasAnswer
        __typename
      }
      completelyAnswered
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePublicAssessmentSubmission = /* GraphQL */ `
  subscription OnCreatePublicAssessmentSubmission(
    $filter: ModelSubscriptionPublicAssessmentSubmissionFilterInput
  ) {
    onCreatePublicAssessmentSubmission(filter: $filter) {
      id
      assessmentID
      customerName
      customerMail
      customerPhone
      customerOrganization
      consentMarketingMails
      preferences
      answerData
      evaluationData
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePublicAssessmentSubmission = /* GraphQL */ `
  subscription OnUpdatePublicAssessmentSubmission(
    $filter: ModelSubscriptionPublicAssessmentSubmissionFilterInput
  ) {
    onUpdatePublicAssessmentSubmission(filter: $filter) {
      id
      assessmentID
      customerName
      customerMail
      customerPhone
      customerOrganization
      consentMarketingMails
      preferences
      answerData
      evaluationData
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePublicAssessmentSubmission = /* GraphQL */ `
  subscription OnDeletePublicAssessmentSubmission(
    $filter: ModelSubscriptionPublicAssessmentSubmissionFilterInput
  ) {
    onDeletePublicAssessmentSubmission(filter: $filter) {
      id
      assessmentID
      customerName
      customerMail
      customerPhone
      customerOrganization
      consentMarketingMails
      preferences
      answerData
      evaluationData
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
